define('apps/classrooms/views/modals/bulk_set_qr_block_message',[
    'app',
    'njs!apps/classrooms/templates/includes/components/_bulk_qr_block_message(params:tmpl=classrooms/includes/components/_bulk_qr_block_message.html)',
], function(app, template) {
    'use strict';

    return Mn.ItemView.extend({

        "template": template,

        "initialize": function(opts){
            this.model.set({
                'allow_close': this.model.get('allClose'),
                'is_complete': this.model.get('isComplete'),
                'is_loading': this.model.get('isLoading'),
                'message': this.model.get('message'),
                'sure_to_continue': this.model.get('sureToContinue'),
                'sure_to_exit': this.model.get('sureToExit'),
            });
        }
    });
});

